export class Column {
    public name: String = '';
    public title: String = '';
    public type: String = 'text';
    public icon: String = 'text';
    public action: Function = () => {};
    public condition: Function = () => {};

    constructor(title: String, name: String, type?: String, icon?: String, action?: Function, condition?: Function) {
        this.name = name;
        this.title = title;
        if (type) { this.type = type; }
        if (icon) { this.icon = icon; }
        if (action) { this.action = action; }
        if (condition) { this.condition = condition; }
    }
}